import Panel from '@/app/_components/Panel'
import StripeCheckoutElement from '@/app/_components/StripeCheckoutElement'

const ExpressCheckout = ({
    expressCheckoutData,
    displayExpressPaymentIcons = true,
    displayStandardPaymentIcons = true,
    usePanel = true,
    showLabel = true,
    headingLevel = 'label',
    headingClassName = '',
    className = ""
}) => {
    const content = (
        <StripeCheckoutElement
            expressCheckoutData={expressCheckoutData}
            displayExpressPaymentIcons={displayExpressPaymentIcons}
            displayStandardPaymentIcons={displayStandardPaymentIcons}
        />
    )

    if (usePanel) {
        return (
            <Panel label={showLabel ? "Express Checkout" : null} className={className} cardClass="card-bg-gray">
                {content}
            </Panel>
        )
    }

    // Render without Panel wrapper
    const HeadingTag = headingLevel === 'h2' ? 'h2' : 'div'
    const defaultHeadingClass = headingLevel === 'h2'
        ? 'block mb-2 text-base font-medium'
        : 'font-medium text-lg text-light mb-2'

    return (
        <div className={className}>
            {showLabel && (
                <HeadingTag className={headingClassName || defaultHeadingClass}>
                    Express Checkout
                </HeadingTag>
            )}
            {content}
        </div>
    )
}

export default ExpressCheckout
